<template>
  <div>
    <div align="left">
      <br />
      <h5 class="h5 mb-1 text-primary font-weight-bold">Banner Homepage</h5>
      <br />
    </div>
    <b-card class="text-left">
      <b>Edit Banner Homepage</b>
      <br />
      <br />
      <br />
      <b-row>
        <b-col md="6">
          <b-form-group
            id="input-group-1"
            label="Banner Image WebP (Desktop):"
            label-for="input-1"
          >
            <!-- <input
              v-model="items.image_desktop_webp"
              v-validate="'required'"
              name="imagedesktop"
              data-vv-as="Url Image Desktop"
              placeholder="Url Image Desktop"
              class="form-control"
            /> -->
            <b-card body-class="py-2 px-2">
              <card-body>
                <b-row>
                  <b-col class="text-primary mt-2">
                    <i class="fas fa-paperclip"></i>&nbsp;
                    <b>Banner Image (Desktop)</b>
                    <sup class="text-secondary pl-3"
                      >(2 Mb)&nbsp;(1920px x 700px)</sup
                    >
                  </b-col>
                  <b-col md="4" class="text-right" align="right">
                    <input
                      type="file"
                      ref="fileDesktop"
                      name="image_desktop_jpg"
                      v-validate="
                        'minimalDimensions:1920,700|ratiolDimensions:96,35|size:2000|ext:jpg,png,gif,jpeg,webp'
                      "
                      style="display: none"
                      v-on:change="onChangeFileDesktop()"
                    />
                    <b-button
                      @click="$refs.fileDesktop.click()"
                      v-show="!items.image_desktop_jpg && !fileDesktop"
                      variant="primary"
                      class="ml-5"
                      >Select File</b-button
                    >
                    <b-button
                      v-show="items.image_desktop_jpg || fileDesktop"
                      variant="primary"
                      @click="modalDesktop = !modalDesktop"
                      class="mr-2"
                      >Preview</b-button
                    >
                    <b-button
                      @click="$refs.fileDesktop.click()"
                      v-show="items.image_desktop_jpg || fileDesktop"
                      variant="outline-primary"
                      class
                      >Change File</b-button
                    >
                  </b-col>
                </b-row>
              </card-body>
            </b-card>
            <p
              class="text-danger"
              style="width: 100%; margin-top: 0.25rem; font-size: 80%"
            >
              {{ veeErrors.first("imagedesktop") }}
            </p>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="input-group-1"
            label="Banner Image WebP (Mobile):"
            label-for="input-1"
          >
            <!-- <input
              v-model="items.image_mobile_webp"
              v-validate="'required'"
              name="imagemobile"
              data-vv-as="Url Image Mobile"
              placeholder="Url Image Mobile"
              class="form-control"
            /> -->
            <b-card body-class="py-2 px-2">
              <card-body>
                <b-row>
                  <b-col class="text-primary mt-2">
                    <i class="fas fa-paperclip"></i>&nbsp;
                    <b>Banner Image (Mobile)</b>
                    <sup class="text-secondary pl-3"
                      >(2 Mb)&nbsp;(640px x 600px)</sup
                    >
                  </b-col>
                  <b-col md="4" class="text-right" align="right">
                    <input
                      type="file"
                      ref="fileMobile"
                      name="imagemobile"
                      v-validate="
                        'minimalDimensions:640,600|ratiolDimensions:64,60|size:2000|ext:jpg,png,gif,jpeg,webp'
                      "
                      style="display: none"
                      v-on:change="onChangeFileMobile()"
                    />
                    <b-button
                      @click="$refs.fileMobile.click()"
                      v-show="!items.image_mobile_jpg && !fileMobile"
                      variant="primary"
                      class="ml-5"
                      >Select File</b-button
                    >
                    <b-button
                      v-show="items.image_mobile_jpg || fileMobile"
                      variant="primary"
                      @click="modalMobile = !modalMobile"
                      class="mr-2"
                      >Preview</b-button
                    >
                    <b-button
                      @click="$refs.fileMobile.click()"
                      v-show="items.image_mobile_jpg || fileMobile"
                      variant="outline-primary"
                      class
                      >Change File</b-button
                    >
                  </b-col>
                </b-row>
              </card-body>
            </b-card>
            <p
              class="text-danger"
              style="width: 100%; margin-top: 0.25rem; font-size: 80%"
            >
              {{ veeErrors.first("imagemobile") }}
            </p>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Heading (Bahasa)"
            label-for="input-1"
          >
            <input
              v-model="items.header_id"
              v-validate="'required'"
              name="title_id"
              data-vv-as="Heading Bahasa"
              placeholder="Heading in Bahasa"
              class="form-control"
            />
            <b-form-invalid-feedback id="input-title_id-feedback">{{
              veeErrors.first("title_id")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Heading (English)"
            label-for="input-1"
          >
            <input
              v-model="items.header_en"
              v-validate="'required'"
              name="title_en"
              data-vv-as="Heading English"
              placeholder="Heading in English"
              class="form-control"
            />
            <b-form-invalid-feedback id="input-title_en-feedback">{{
              veeErrors.first("title_en")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col></b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Sub Heading (Bahasa)"
            label-for="input-1"
          >
            <ckeditor
              :editor="editor"
              :config="editorConfig"
              v-model="items.sub_heading_id"
              tag-name="textarea"
              placeholder="Sub Heading Bahasa"
              v-validate="'required'"
              name="sub_title_id"
              data-vv-as="Sub Heading Bahasa"
              class="form-control"
            ></ckeditor>
            <p
              class="text-danger"
              style="width: 100%; margin-top: 0.25rem; font-size: 80%"
            >
              {{ veeErrors.first("sub_title_id") }}
            </p>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Sub Heading (English)"
            label-for="input-1"
          >
            <ckeditor
              :editor="editor"
              :config="editorConfig"
              v-model="items.sub_heading_en"
              tag-name="textarea"
              placeholder="Sub Heading English"
              v-validate="'required'"
              name="sub_title_en"
              data-vv-as="Sub Heading English"
              class="form-control"
            ></ckeditor>
            <p
              class="text-danger"
              style="width: 100%; margin-top: 0.25rem; font-size: 80%"
            >
              {{ veeErrors.first("sub_title_en") }}
            </p>
          </b-form-group>
        </b-col>
        <b-col></b-col>
      </b-row>
      <br />
      <b-row>
        <b-col md="6">
          <b-form-group id="fieldset-1" label="With Button" label-for="input-1">
            <b-form-radio-group
              id="radio-group-1"
              v-model="items.is_with_button"
              :options="options1"
              name="radio-options"
            ></b-form-radio-group>
          </b-form-group>
        </b-col>
        <br />
      </b-row>
      <b-row v-show="items.is_with_button">
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Button Text (Bahasa)"
            label-for="input-1"
          >
            <input
              :disabled="items.is_with_button == false"
              v-model="items.button.text_button_id"
              v-validate="'required'"
              data-vv-as="Button Text Bahasa"
              name="button_id"
              class="form-control"
              placeholder="Button Text in Bahasa"
            />
            <b-form-invalid-feedback id="input-question_id-feedback">{{
              veeErrors.first("button_id")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Button Text (English)"
            label-for="input-1"
          >
            <input
              :disabled="items.is_with_button == false"
              v-model="items.button.text_button_en"
              v-validate="'required'"
              data-vv-as="Button Text English"
              name="button_en"
              class="form-control"
              placeholder="Button Text in English"
            />
            <b-form-invalid-feedback id="input-question_id-feedback">{{
              veeErrors.first("button_en")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col></b-col>
        <br />
      </b-row>
      <b-row v-show="items.is_with_button">
        <b-col md="6">
          <b-form-group id="fieldset-1" label="Button Url" label-for="input-1">
            <b-form-radio-group
              id="radio-group-url"
              v-model="items.button.is_article"
              :options="options3"
              name="radio-url"
            ></b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-show="items.is_with_button">
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Article"
            label-for="input-1"
            v-show="items.button.is_article == true"
          >
            <vue-multiselect
              id="ajax2"
              open-direction="bottom"
              v-model="items.button.article"
              v-validate="
                items.button.is_article == true && items.is_with_button == true
                  ? 'required'
                  : ''
              "
              data-vv-as="Article Url"
              name="article_url"
              :preserve-search="true"
              :options="dataArticle"
              :custom-label="nameWithLang"
              placeholder="Type to search Article"
              track-by="id"
              label="title"
              class="text-capitalize"
              :loading="isLoadingArticle"
              :searchable="true"
              @search-change="asyncFindArticle"
            >
              <template slot="singleLabel" slot-scope="{ option }">
                <span>{{ option.title.id }}</span>
              </template>
              <template slot="option" slot-scope="props">
                <div class="option__desc">
                  <span class="option__title">{{ props.option.title.id }}</span>
                </div>
              </template>
            </vue-multiselect>
            <p
              class="text-danger"
              style="width: 100%; margin-top: 0.25rem; font-size: 80%"
            >
              {{ veeErrors.first("article_url") }}
            </p>
          </b-form-group>
          <b-form-group
            id="fieldset-1"
            label="Other URL"
            label-for="input-1"
            v-show="items.button.is_article == false"
          >
            <input
              v-model="items.button.other_url"
              v-validate="
                items.button.is_article == false && items.is_with_button == true
                  ? 'required|url: {require_protocol: true }'
                  : 'url: {require_protocol: true }'
              "
              name="button_url"
              data-vv-as="Other URL"
              class="form-control"
              placeholder="URL"
            />
            <p
              class="text-danger"
              style="width: 100%; margin-top: 0.25rem; font-size: 80%"
            >
              {{ veeErrors.first("button_url") }}
            </p>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="With Download Button"
            label-for="input-1"
          >
            <b-form-radio-group
              id="download-button"
              v-model="items.is_with_download_button"
              :options="options1"
              name="download-button"
            ></b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-show="items.is_with_download_button">
        <b-col md="6">
          <b-form-group id="fieldset-1" label="Play Store" label-for="input-1">
            <b-card body-class="py-2 px-2">
              <card-body>
                <b-row>
                  <b-col class="text-primary mt-2">
                    <i class="fas fa-paperclip"></i>&nbsp;
                    <b>Icon Download Play Store</b>
                    <sup class="text-secondary pl-3"
                      >(2 Mb)&nbsp;(160px x 50px)</sup
                    >
                  </b-col>
                  <b-col md="4" class="text-right" align="right">
                    <input
                      type="file"
                      ref="play_store_icon"
                      name="playstoreicon"
                      v-validate="
                        items.is_with_download_button == true &&
                        !items.download_button.play_store_icon
                          ? 'required|minimalDimensions:160,50|size:2000|ext:jpg,png,gif,jpeg,svg,webp'
                          : 'minimalDimensions:160,50|size:2000|ext:jpg,png,gif,jpeg,svg,webp'
                      "
                      style="display: none"
                      @change="onChangeFilePlayStore()"
                    />
                    <b-button
                      @click="$refs.play_store_icon.click()"
                      v-show="
                        !items.download_button.play_store_icon &&
                        !play_store_icon
                      "
                      variant="primary"
                      class="ml-5"
                      >Select Icon</b-button
                    >
                    <b-button
                      v-show="
                        items.download_button.play_store_icon || play_store_icon
                      "
                      variant="primary"
                      @click="modalPlayStore = !modalPlayStore"
                      class="mr-2"
                      >Preview</b-button
                    >
                    <b-button
                      @click="$refs.play_store_icon.click()"
                      v-show="
                        items.download_button.play_store_icon || play_store_icon
                      "
                      variant="outline-primary"
                      class
                      >Change File</b-button
                    >
                  </b-col>
                </b-row>
              </card-body>
            </b-card>
            <p
              class="text-danger"
              style="width: 100%; margin-top: 0.25rem; font-size: 80%"
            >
              {{ veeErrors.first("playstoreicon") }}
            </p>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group id="fieldset-1" label="App Store" label-for="input-1">
            <b-card body-class="py-2 px-2">
              <card-body>
                <b-row>
                  <b-col class="text-primary mt-2">
                    <i class="fas fa-paperclip"></i>&nbsp;
                    <b>Icon Download App Store</b>
                    <sup class="text-secondary pl-3"
                      >(2 Mb)&nbsp;(160px x 50px)</sup
                    >
                  </b-col>
                  <b-col md="4" class="text-right" align="right">
                    <input
                      type="file"
                      ref="app_store_icon"
                      name="appstoreicon"
                      v-validate="
                        items.is_with_download_button == true &&
                        !items.download_button.app_store_icon
                          ? 'required|minimalDimensions:160,50|size:2000|ext:jpg,png,gif,jpeg,svg,webp'
                          : 'minimalDimensions:160,50|size:2000|ext:jpg,png,gif,jpeg,svg,webp'
                      "
                      style="display: none"
                      @change="onChangeFileAppStore()"
                    />
                    <b-button
                      @click="$refs.app_store_icon.click()"
                      v-show="
                        !items.download_button.app_store_icon && !app_store_icon
                      "
                      variant="primary"
                      class="ml-5"
                      >Select Icon</b-button
                    >
                    <b-button
                      v-show="
                        items.download_button.app_store_icon || app_store_icon
                      "
                      variant="primary"
                      @click="modalAppStore = !modalAppStore"
                      class="mr-2"
                      >Preview</b-button
                    >
                    <b-button
                      @click="$refs.app_store_icon.click()"
                      v-show="
                        items.download_button.app_store_icon || app_store_icon
                      "
                      variant="outline-primary"
                      class
                      >Change File</b-button
                    >
                  </b-col>
                </b-row>
              </card-body>
            </b-card>
            <p
              class="text-danger"
              style="width: 100%; margin-top: 0.25rem; font-size: 80%"
            >
              {{ veeErrors.first("appstoreicon") }}
            </p>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group id="fieldset-1" label-for="input-1">
            <input
              v-model="items.download_button.play_store_url"
              v-validate="
                items.is_with_download_button == true
                  ? 'required|url: {require_protocol: true }'
                  : 'url: {require_protocol: true }'
              "
              data-vv-as="URL Play Store"
              name="play_store_url"
              class="form-control"
              placeholder="URL Play Store"
            />
            <b-form-invalid-feedback id="input-question_id-feedback">{{
              veeErrors.first("play_store_url")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group id="fieldset-1" label-for="input-1">
            <input
              v-model="items.download_button.app_store_url"
              v-validate="
                items.is_with_download_button == true
                  ? 'required|url: {require_protocol: true }'
                  : 'url: {require_protocol: true }'
              "
              data-vv-as="URL App Store"
              name="app_store_url"
              class="form-control"
              placeholder="URL App Store"
            />
            <b-form-invalid-feedback id="input-question_id-feedback">{{
              veeErrors.first("app_store_url")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group id="fieldset-1" label="Status" label-for="input-1">
            <b-form-radio-group
              id="radio-group-2"
              v-model.trim="items.status"
              :options="options2"
              name="radio-status"
            ></b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col>
          <b-form-group id="fieldset-1" label="Period" label-for="input-1">
            <b-form-group id="fieldset-1" label-for="input-1">
              <b-row class="m-0">
                <b-col
                  class="pr-0 pt-1 form-control img-calender-select border-right-0"
                  md="2"
                >
                  <img
                    src="@/assets/ic-calendar-copy-30.svg"
                    width="25px"
                    alt
                    class
                  />
                </b-col>
                <b-col class="px-0">
                  <datepicker
                    input-class="form-control text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                    placeholder="Select Date"
                    v-model="items.start_date"
                    :format="customFormatter"
                    :disabled="items.is_always_active"
                    :disabledDates="disabledDates"
                  ></datepicker>
                </b-col>
                <b-col align="left" md="1" class="px-0">
                  <b-col
                    class="pt-1 px-4 form-control del-calender-select border-left-0"
                    md="2"
                  >
                    <b-row class="pt-1">
                      <b-col>
                        <b-link
                          @click="resetStardate"
                          style="text-decoration: none"
                        >
                          <i class="text-danger fas fa-times"></i>
                        </b-link>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-col>
              </b-row>
            </b-form-group>
          </b-form-group>
        </b-col>
        <b-col>
          <p class="mb-2">&nbsp;</p>
          <b-form-group id="fieldset-1" label-for="input-1">
            <b-row class="m-0">
              <b-col
                class="pr-0 pt-1 form-control img-calender-select border-right-0"
                md="2"
              >
                <img
                  src="@/assets/ic-calendar-copy-30.svg"
                  width="25px"
                  alt
                  class
                />
              </b-col>
              <b-col class="px-0">
                <datepicker
                  input-class="form-control text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                  placeholder="Select Date"
                  v-model="items.end_date"
                  :format="customFormatter"
                  :disabled="items.is_always_active"
                  :disabledDates="disabledDates"
                ></datepicker>
              </b-col>
              <b-col align="left" md="1" class="px-0">
                <b-col
                  class="pt-1 px-4 form-control del-calender-select border-left-0"
                  md="2"
                >
                  <b-row class="pt-1">
                    <b-col>
                      <b-link
                        @click="resetEnddate"
                        style="text-decoration: none"
                      >
                        <i class="text-danger fas fa-times"></i>
                      </b-link>
                    </b-col>
                  </b-row>
                </b-col>
              </b-col>
            </b-row>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <br />
      <b-row>
        <b-col align="right">
          <b-button
            variant="primary"
            @click="put()"
            :disabled="loading"
            size="lg"
            class="mr-3"
            >Save</b-button
          >
          <router-link :to="{ name: 'bannerLocker' }">
            <b-button size="lg" variant="outline-secondary">Cancel</b-button>
          </router-link>
        </b-col>
      </b-row>
    </b-card>
    <b-modal v-model="modalMobile" title="Preview Image" size="xl">
      <img
        v-show="!fileMobile"
        v-if="items.image_mobile_jpg"
        width
        height="400px"
        :src="items.image_mobile_jpg"
      />
      <img
        v-show="fileMobile"
        v-if="urlMobile"
        width
        height="400px"
        :src="urlMobile"
      />
    </b-modal>
    <b-modal v-model="modalDesktop" title="Preview Image" size="xl">
      <img
        v-show="!fileDesktop"
        v-if="items.image_desktop_jpg"
        width
        height="400px"
        :src="items.image_desktop_jpg"
      />
      <img
        v-show="fileDesktop"
        v-if="urlDesktop"
        width
        height="400px"
        :src="urlDesktop"
      />
    </b-modal>
    <b-modal v-model="modalPlayStore" title="Preview Image" size="xl">
      <img
        v-show="urlPlayStore"
        v-if="urlPlayStore"
        width
        height="400px"
        :src="urlPlayStore"
      />
      <img
        v-show="!urlPlayStore"
        v-if="items.download_button.play_store_icon"
        width
        height="400px"
        :src="items.download_button.play_store_icon"
      />
    </b-modal>
    <b-modal v-model="modalAppStore" title="Preview Image" size="xl">
      <img
        v-show="urlAppStore"
        v-if="urlAppStore"
        width
        height="400px"
        :src="urlAppStore"
      />
      <img
        v-show="!urlAppStore"
        v-if="items.download_button.app_store_icon"
        width
        height="400px"
        :src="items.download_button.app_store_icon"
      />
    </b-modal>
    <br />
    <br />
  </div>
</template>

<script>
import _ from "lodash";
import Datepicker from "vuejs-datepicker";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { mixInCkeditor } from "@/mixin/mixInCkeditor";

export default {
  mixins: [mixInCkeditor],
  components: {
    Datepicker,
  },
  data() {
    return {
      editor: ClassicEditor,
      widthMobile: null,
      heightMobile: null,
      widthDesktop: null,
      heightDesktop: null,
      InputImageMobile: false,
      InputImageDesktop: false,
      modalMobile: false,
      modalDesktop: false,
      fileDesktop: "",
      fileMobile: "",
      urlMobile: "",
      urlDesktop: "",
      isLoadingArticle: false,
      searchTermArticle: "",
      modalPlayStore: false,
      modalAppStore: false,
      play_store_icon: "",
      play_store_url: "",
      app_store_icon: "",
      app_store_url: "",
      urlAppStore: "",
      urlPlayStore: "",
      dataArticle: [],
      items: [],
      options: [],
      options1: [
        { text: "No", value: false },
        { text: "Yes", value: true },
      ],
      options3: [
        { text: "Article", value: true },
        { text: "Other URL", value: false },
      ],
      options2: [
        { text: "Publish", value: "publish" },
        { text: "Archive", value: "archive" },
      ],
      disabledDates: {
        to: new Date(Date.now() - 8640000),
      },
    };
  },
  beforeCreate() {
    this.$store.dispatch(
      "bannerLockerModule/getBannerMicroisite",
      this.$route.params.id
    );
    const formData = new FormData();
    formData.append("search_param", "");
    formData.append("limit", 10);
    formData.append("page", 1);
    formData.append("status", "publish");
    formData.append("status", "highlight");
    this.$store
      .dispatch("ArticleModule/getArticles2", formData)
      .then((response) => {
        this.dataArticle = response.data.data.results;
        this.isLoadingArticle = false;
      })
      .catch((error) => {
        this.$swal({
          type: "error",
          title: "Oops...",
          text: error.response.data.message,
          showConfirmButton: false,
          timer: 1500,
        });
        this.isLoadingArticle = false;
      });
  },
  created() {
    this.$store.watch(
      (state) => state.bannerLockerModule.banner_microsite_id,
      (newValue, oldValue) => {
        this.items = newValue;
        // Do whatever makes sense now
        if (this.items.length === 0) {
          this.loading = true;
        } else {
          this.loading = false;
        }
      }
    );
  },
  methods: {
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    resetStardate() {
      this.items.period.start_date = "";
    },
    resetEnddate() {
      this.items.period.end_date = "";
    },
    asyncFindArticle(query) {
      this.isLoadingArticle = true;
      this.searchTermArticle = query;
      this.getWorksAsync();
    },
    getWorksAsync: _.debounce(function () {
      const article = this.searchTermArticle.toLowerCase();
      const formData = new FormData();
      formData.append("param", article);
      formData.append("limit", 10);
      formData.append("page", 1);
      formData.append("status", "publish");
      formData.append("status", "highlight");
      this.$store
        .dispatch("ArticleModule/getArticles2", formData)
        .then((response) => {
          this.dataArticle = response.data.data.results;
          this.isLoadingArticle = false;
        })
        .catch((error) => {
          this.$swal({
            type: "error",
            title: "Oops...",
            text: error.response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
          this.isLoadingArticle = false;
        });
    }, 1000),
    put() {
      this.$swal({
        title: "Are you sure?",
        text: "You will update this Banner Locker!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, update it!",
      }).then((result) => {
        if (result.value) {
          this.$validator.validateAll().then((result) => {
            if (result) {
              this.loading = true;
              const formData = new FormData();
              formData.append("image_desktop_jpg", this.fileDesktop);
              formData.append("image_mobile_jpg", this.fileMobile);
              formData.append("header_id", this.items.header_id);
              formData.append("header_en", this.items.header_en);
              formData.append("sub_heading_id", this.items.sub_heading_id);
              formData.append("sub_heading_en", this.items.sub_heading_en);
              formData.append(
                "text_button_id",
                this.items.button.text_button_id
              );
              formData.append(
                "text_button_en",
                this.items.button.text_button_en
              );
              formData.append(
                "is_with_download_button",
                this.items.is_with_download_button
              );
              formData.append("play_store_icon", this.play_store_icon);
              formData.append("app_store_icon", this.app_store_icon);

              formData.append(
                "play_store_url",
                this.items.download_button.play_store_url
              );
              formData.append(
                "app_store_url",
                this.items.download_button.app_store_url
              );

              formData.append("is_article", this.items.button.is_article);

              if (this.items.button.is_article) {
                formData.append("article_id", this.items.button.article.id);
              }
              formData.append("other_url", this.items.button.other_url);
              formData.append("is_with_button", this.items.is_with_button);

              if (this.items.start_date == "" && this.items.end_date != "") {
                const endDate = moment(this.items.end_date).format(
                  "YYYY-MM-DD"
                );
                formData.append("period_start", this.items.start_date);
                formData.append("period_end", endDate);
              }
              if (this.items.start_date != "" && this.items.end_date == "") {
                const startDate = moment(this.items.start_date).format(
                  "YYYY-MM-DD"
                );
                formData.append("period_start", startDate);
                formData.append("period_end", this.items.end_date);
              }
              if (this.items.start_date != "" && this.items.end_date != "") {
                const startDate = moment(this.items.start_date).format(
                  "YYYY-MM-DD"
                );
                const endDate = moment(this.items.end_date).format(
                  "YYYY-MM-DD"
                );

                formData.append("period_start", startDate);
                formData.append("period_end", endDate);
              }
              if (this.items.start_date == "" && this.items.end_date == "") {
                formData.append("period_start", this.items.start_date);
                formData.append("period_end", this.items.end_date);
              }

              formData.append("status", this.items.status);
              this.$store
                .dispatch("bannerLockerModule/putBannerMicroisites", {
                  id: this.$route.params.id,
                  formData,
                })
                .then((response) => {
                  this.loading = false;
                  this.$router.push({ name: "bannerLocker" });
                  this.$swal({
                    type: "success",
                    title: "Your work has been saved",
                    showConfirmButton: false,
                    timer: 1500,
                  });
                  console.log(response);
                })
                .catch((error) => {
                  this.loading = false;
                  this.$swal({
                    type: "error",
                    title: "Oops...",
                    text: error.response.data,
                    showConfirmButton: false,
                    timer: 1500,
                  });
                  this.serverError = error.response.data;
                  console.log(error);
                });
            } else {
              this.$swal({
                type: "error",
                title: "Oops...",
                text: this.$validator.errors.all(),
                showConfirmButton: false,
                timer: 1500,
              });
            }
          });
        }
      });
    },
    onChangeFileDesktop() {
      this.fileDesktop = this.$refs.fileDesktop.files[0];
      const input = this.$refs.fileDesktop;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.onload = () => {
            this.widthDesktop = img.width;
            this.heightDesktop = img.height;
          };
          img.src = e.target.result;
          this.urlDesktop = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    onChangeFileMobile() {
      this.fileMobile = this.$refs.fileMobile.files[0];
      const input = this.$refs.fileMobile;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.onload = () => {
            this.widthMobile = img.width;
            this.heightMobile = img.height;
          };
          img.src = e.target.result;
          this.urlMobile = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    onChangeFileAppStore() {
      this.app_store_icon = this.$refs.app_store_icon.files[0];
      const input = this.$refs.app_store_icon;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;
          this.urlAppStore = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    onChangeFilePlayStore() {
      this.play_store_icon = this.$refs.play_store_icon.files[0];
      const input = this.$refs.play_store_icon;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;
          this.urlPlayStore = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
  },
};
</script>

<style>
</style>
